export default {
  template: '#syllabus-block-picker-template',
  data() {
    return {
      buttons: [
        {
          text: 'Section Title',
          iconClass: 'kf-section-break',
          eventPayload: 'title'
        },
        {
          text: 'Text',
          iconClass: 'kf-rich-text',
          eventPayload: 'text'
        },
        {
          text: 'Spacer',
          iconClass: 'kf-move',
          eventPayload: 'spacer'
        },
        {
          text: 'Course Image',
          iconClass: 'kf-course-image',
          eventPayload: 'course-logo'
        },
        {
          text: 'Course Promo Video',
          iconClass: 'kf-course-promo-video',
          eventPayload: 'course-promo'
        },
        {
          text: Kadenze.I18n.n('Instructors'),
          iconClass: 'kf-instructors',
          eventPayload: 'instructors-list'
        },
        {
          text: 'Image',
          iconClass: 'kf-insert_photo',
          eventPayload: 'image'
        },
        {
          text: 'Video',
          iconClass: 'kf-video',
          eventPayload: 'video'
        },
        { 
          text: 'Audio',
          iconClass: 'kf-audio',
          eventPayload: 'audio'
        },
        {
          text: 'Grading Policy',
          iconClass: 'kf-grading-policy',
          eventPayload: 'grading-policy'
        },
        { 
          text: 'Coursework List',
          iconClass: 'kf-coursework',
          eventPayload: 'coursework-list'
        },
        {
          text: 'Session Schedule',
          iconClass: 'kf-sessions',
          eventPayload: 'session-list'
        },
        {
          text: 'PDF Document',
          iconClass: 'kf-pdf',
          eventPayload: 'pdf'
        },
      ]
    }; 
  }
};
